export default location =>
  ({ room }) =>
    room.facility.sfid === location;
